/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

import Skeleton from '@mui/material/Skeleton';

const ViewLoader = ({ type }) => (
  <>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <div className="panel panel-collapsed w-100">
          <div className="panel-container">
            <div className="panel-content  ">
              <div className="d-flex flex-column align-items-center justify-content-center p-4">
                { type === 'agent' ? (
                  <div style={{
                    borderRadius: '50%',
                    width: '100%',
                    maxWidth: '280px',
                    height: '280px',
                    backgroundColor: 'var(--theme-secondary)',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    color: '#fff',
                  }}
                  >
                    <i className="fas fa-user fa-9x" />
                  </div>
                ) : (
                  <div style={{
                    width: '100%',
                    height: '250px',
                    maxHeight: '250px',
                    backgroundColor: 'var(--theme-secondary)',
                    borderRadius: '4px',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    color: '#fff',

                  }}
                  >
                    { type === 'listings' ? <i className="fas fa-home fa-6x" /> : <i className="fas fa-home fa-6x" /> }
                  </div>
                )}
                <div className="mt-2" style={{ width: '100%' }}>
                  <h3 className="mb-0 text-center">
                    <Skeleton />
                  </h3>
                  <p className="mb-4 text-center mt-2" />
                  <p className="mb-4 text-center mt-4 mb-2">
                    <Skeleton />
                  </p>
                  <p className="mb-4 text-center mt-4 mb-2">
                    <Skeleton />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-8 d-flex">
        <div className="panel panel-collapsed w-100">
          <div className="panel-hdr">
            <h2><Skeleton height={48} width={300} /></h2>
          </div>
          <div className="panel-container">
            <div className="panel-content  ">
              <table className="table borderless">
                <tbody>
                  <tr>
                    <td><Skeleton height={30} /></td>
                    <td><Skeleton /></td>
                  </tr>
                  <tr>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                  </tr>
                  <tr>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                  </tr>
                  <tr>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                  </tr>
                  <tr>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

ViewLoader.propTypes = {
  type: PropTypes.string.isRequired,
};

export default ViewLoader;
